import { Component, Input } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div>
  <se-po-organization-list [personaId]="personaId" access="manager">
  </se-po-organization-list>
</div>
`

const exampleTypescript = `
import { Component, Input } from '@angular/core'

export class OrganizationListExampleComponent {
  @Input() public personaId: string | number
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-organization-list-example',
  template,
  styleUrls: ['./organization-list-docs.component.scss'],
  standalone: false,
})
export class OrganizationListExampleComponent extends SeFeDocsExampleComponent {
  @Input() public personaId: string | number
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  constructor() {
    super()
  }
}
